import * as React from 'react'
import FlatPagination from 'material-ui-flat-pagination'
import { PaginationState } from '../types/pagination'

interface Props {
  pagination: PaginationState
  onPageChange: (page: number) => void
  perPage?: number  // deprecated: use pagination.perPage instead
}

/**
 * Reusable pagination component using material-ui-flat-pagination
 * Maintains the same UI as the old pagination while supporting server-side pagination
 */
export const Pagination: React.FC<Props> = ({
  pagination,
  onPageChange,
  perPage: perPageProp
}) => {
  const { page, totalPages, total, perPage: paginationPerPage } = pagination
  // Use perPage from pagination state (from BE), fallback to prop, then default
  const perPage = paginationPerPage || perPageProp || 100

  // Don't render if only 1 page or no data
  if (totalPages <= 1 || total === 0) return null

  // Convert page-based to offset-based for FlatPagination
  const offset = (page - 1) * perPage

  const handleClick = (_e: React.MouseEvent, newOffset: number) => {
    const newPage = Math.floor(newOffset / perPage) + 1
    if (newPage !== page) {
      onPageChange(newPage)
    }
  }

  return (
    <div style={{ textAlign: "center", margin: "10px 0" }}>
      <FlatPagination
        limit={perPage}
        offset={offset}
        total={total}
        onClick={handleClick}
      />
    </div>
  )
}

export default Pagination
